import { get } from 'modules/api';

export const fetchStripeOnboardingLink = companyId =>
    get(`payment/stripe/company/${companyId}/connected-account-onboarding`);
